import { Topup } from "@/pages/Topup"
import { DepositType, IBANContext, useIBANContext, useStoreClient } from "@usher/pe-client-front-end-lib"
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom"
import { OrderIban } from "./Order"
import { Payments } from "./Payments"
import { NewPayment } from "./Payments/NewPayment"
import { Requisites } from "./Requisites"

export const Iban = () => {
  const { path } = useRouteMatch()
  const { iban_active } = useStoreClient((state) => state.user)
  const contextValue = useIBANContext()
  if (!iban_active) return <Redirect to="/client" />
  return (
    <IBANContext.Provider value={contextValue}>
      <Switch>
        <Route path={`${path}/order`} component={OrderIban} />
        <Route path={`${path}/topup`}>
          <Topup depositType={DepositType.IBAN} />
        </Route>
        <Route path={`${path}/payments`} component={Payments} />
        <Route path={`${path}/requisites/:ibanId?`} component={Requisites} />
        <Route path={`${path}/new-payment`} component={NewPayment} />
      </Switch>
    </IBANContext.Provider>
  )
}
